import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import OTPLogin from "@/pages/OTPLogin";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import AIGuide from "@/pages/AIGuide";
import Doctors from "@/pages/Doctors";
import Appointments from "@/pages/Appointments";
import LabReports from "@/pages/LabReports";
import Pharmacy from "@/pages/Pharmacy";
import Nutrition from "@/pages/Nutrition";
import Emergency from "@/pages/Emergency";
import Profile from "@/pages/Profile";
import AdminDashboard from "@/pages/AdminDashboard";
import DoctorPortal from "@/pages/DoctorPortal";
import HospitalPortal from "@/pages/HospitalPortal";
import LabAdminPortal from "@/pages/LabAdminPortal";
import VideoRoom from "@/pages/VideoRoom";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

import "@/App.css";

function AppRoot() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="ai" element={<AIGuide />} />
        <Route path="doctors" element={<Doctors />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="labs" element={<LabReports />} />
        <Route path="pharmacy" element={<Pharmacy />} />
        <Route path="nutrition" element={<Nutrition />} />
        <Route path="emergency" element={<Emergency />} />
        <Route path="profile" element={<Profile />} />
        <Route path="*" element={<Navigate to="/app" replace />} />
      </Routes>
    </AppLayout>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/login/otp" element={<OTPLogin />} />
            <Route path="/register" element={<Register />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/onboarding" element={
              <ProtectedRoute><Onboarding /></ProtectedRoute>
            } />
            <Route path="/app/*" element={
              <ProtectedRoute><AppRoot /></ProtectedRoute>
            } />
            <Route path="/video/:apptId" element={
              <ProtectedRoute><VideoRoom /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
            } />
            <Route path="/doctor" element={
              <ProtectedRoute roles={["doctor", "admin"]}><DoctorPortal /></ProtectedRoute>
            } />
            <Route path="/hospital" element={
              <ProtectedRoute roles={["hospital_admin", "admin"]}><HospitalPortal /></ProtectedRoute>
            } />
            <Route path="/lab" element={
              <ProtectedRoute roles={["lab_admin", "admin", "doctor"]}><LabAdminPortal /></ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
